// Infinite Options by ShopPad
// This theme removes event handlers attached to the add to cart button when the variant changes
// Reinit Infinite Options to reattach event handlers
document.addEventListener('variant:changed', function(event) {
  window.Shoppad.apps.infiniteoptions.init();
});

var splide = new Splide( '.splide', {
  perPage: 3,
  breakpoints: {
      991: {
          perPage: 2,
      },
      640: {
          perPage: 1,
      },
  },
  perMove: 1,
  //focus  : 'center',
  //omitEnd: true,
  type: 'loop',
  pagination: false,
} );

splide.mount();